import React from "react";
import "../../hooks/useBreakpoints";
import { useBreakpoints } from "../../hooks/useBreakpoints";

const Curve = ({ color }) => {
  const { lg } = useBreakpoints();
  return (
    <div>
      {lg ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          preserveAspectRatio="none"
          height="112"
          viewBox="0 0 1366 112"
          fill="none"
          style={{ marginTop: "-60px" }}
        >
          <path
            d="M1366 23.4856L1290.11 34.0018C1214.22 44.3604 1062.44 65.629 910.667 59.209C758.889 53.0254 607.111 19.1531 455.333 6.66769C303.556 -6.05408 151.778 2.61091 75.8888 6.66769L1.19178e-07 10.882L1.22344e-06 111.711L75.8888 111.711C151.778 111.711 303.556 111.711 455.333 111.711C607.111 111.711 758.889 111.711 910.667 111.711C1062.44 111.711 1214.22 111.711 1290.11 111.711L1366 111.711L1366 23.4856Z"
            style={{fill:`var(${color})`}}
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          preserveAspectRatio="none"
          height="32"
          viewBox="0 0 360 32"
          fill="none"
          style={{ marginTop: "-20px" }}
        >
          <path
            d="M360 6.60813L340 9.56703C320 12.4816 280 18.4659 240 16.6595C200 14.9196 160 5.38909 120 1.87608C80 -1.70342 40 0.734627 20 1.87607L-2.36267e-07 3.06185L-2.42543e-06 31.4318L20 31.4318C40 31.4318 80 31.4319 120 31.4319C160 31.4319 200 31.4319 240 31.4319C280 31.4319 320 31.4319 340 31.4319L360 31.4319L360 6.60813Z"
            style={{fill:`var(${color})`}}
          />
        </svg>
      )}
    </div>
  );
};

export default Curve;
